import dayjs from 'dayjs';

export const SECONDS_OF_MINUTE = 60;
export const SECONDS_OF_HOUR = 3600;
export const SECONDS_OF_DAY = 24 * 3600;

let diffTime = 0; // 默认秒差 setSvrTime 计算

/**
 * 毫秒转秒，取整，入参 milliseconds 单位为毫秒
 *
 * @export
 * @returns 秒
 */
export const millisecondsToSeconds = (milliseconds: number) => {
  return Math.floor(milliseconds / 1000);
};

/**
 * 获取标准时间
 *
 * @exports
 * @returns 秒
 */
export const current = () => {
  return millisecondsToSeconds(Date.now()) + diffTime;
};

/**
 * 判断时间是否是今天，入参秒
 *
 * @exports
 * @returns
 */
export const isToday = (ts: number): boolean => {
  return dayjs(current() * 1000).isSame(forceToSeconds(ts) * 1000, 'day');
};

/**
 * 判断时间是否是明天，入参秒
 *
 * @exports
 * @returns
 */
export const isTomorrow = (ts: number): boolean => {
  const today = dayjs(current() * 1000)
    .hour(0)
    .minute(0)
    .second(0)
    .valueOf();
  const tomorrow = dayjs(forceToSeconds(ts) * 1000)
    .hour(0)
    .minute(0)
    .second(0)
    .valueOf();
  return tomorrow - today === SECONDS_OF_DAY * 1000;
};

/**
 * 是否为秒单位，入参 value 单位为秒或者毫秒
 *
 * 2020年时
 * 如果是毫秒单位 转时间戳后 长度为 13
 * 如果是秒单位 转时间戳后 长度为 10
 *
 * 1980-01-01 00:00:00 的毫秒单位 转时间戳后 长度为 12
 * 2002-01-01 00:00:00 的毫秒单位 转时间戳后 长度为 13
 *
 * 5000-12-31 23:59:59 的秒单位 转时间戳后 长度为 11
 * 9999-12-31 23:59:59 的秒单位 转时间戳后 长度为 12
 *
 * 使用 13 作为临界点 可在年份为 [2002, 9999] 内区分秒与毫秒
 * 使用 12 作为临界点 可在年份为 [1980, 5000] 内区分秒与毫秒
 *
 * @export
 * @returns
 */
export const isSeconds = (value: number) => {
  return `${value}`.length < 13;
};

/**
 * 强制转为秒单位，取整。入参 value 单位为秒或者毫秒
 *
 * @export
 * @returns 秒
 */
export const forceToSeconds = (value: number) => {
  return isSeconds(value) ? value : millisecondsToSeconds(value);
};

/**
 * 当前服务器时间戳，单位为秒
 *
 * @export
 * @returns 秒
 */
export const getSvrTime = () => {
  return millisecondsToSeconds(Date.now()) + diffTime;
};

/**
 * 根据服务器时间，计算秒差，入参 seconds 单位为秒
 *
 * @export
 * @returns 秒
 */
export const setSvrTime = (seconds: number) => {
  diffTime = forceToSeconds(seconds) - millisecondsToSeconds(Date.now());
};

/**
 * 返回秒差，单位为秒
 *
 * @export
 * @returns 秒
 */
export const getDiffTime = () => {
  return diffTime;
};
